export const blockIconsPhotoandimageFilterAltNew = (
	<span className='material-symbols-outlined'>filter_alt</span>
);
